<template>
<div class="home" ref="box">
    <div class="downing" v-if="downing">
        <span></span>
        <b>真铺源 无中介 新上铺源抢先看</b>
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.example.dc.zupubao">APP下载</a>
        <s @click="downing=false"></s>
    </div>
    <div class="searchNav" :class="navBarFixed == true ? 'navBarWrap' :''">
        <dl>
            <dt><span @click="goCitySelection()">{{cityNameStr}}</span><b></b></dt>
            <dd @click="goSearch()">
                <span>
                    <img src="../../../static/images/home/search.png">
                </span>
                <p>区域/商圈/业态/商铺编号</p>
            </dd>
        </dl>
        <!-- <i class="telephone" @click="telephone()"> -->
        <!-- <i class="telephone" @click="goMessageuser()"> -->
        <i class="telephone" @click="telephone()"> 
            <!-- <img src="../../../static/images/home/phone.png"> -->
            <img src="../../../static/images/home/kefu-icon.png">
        </i>
    </div>

    <!-- 轮播图 -->
    <div class="homeTop">
        <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item,index) in picArr" style="width: 100%; height: 100%;">
                <div style="width: 100%; height: 100%;" @click="goNewInfo(item.artitleId,item.urlApp,item.flag)">
                    <img :src="item.url">
                </div>
            </mt-swipe-item>
        </mt-swipe>
    </div>

    <!-- 图标 -->
    <div class="homeCenter">
        <div>
            <dl>
                <router-link :to="{name:'lookShop',params:{more:1}}">
                    <dt>
                        <img src="../../../static/images/home/dl1.png">
                    </dt>
                    <dd>查看商铺</dd>
                </router-link>
            </dl>
            <dl>
                <router-link to='/zhuanpuserve'>
                    <dt>
                        <img src="../../../static/images/home/dl7.png">
                    </dt>
                    <dd>极速转铺</dd>
                </router-link>
            </dl>
            <dl>
                <router-link to='/zhaopuserve'>
                    <dt>
                        <img src="../../../static/images/home/dl3.png">
                    </dt>
                    <dd>极速找铺</dd>
                </router-link>
            </dl>
            <dl @click="goMakeMoney()">
                <dt>
                    <img src="../../../static/images/home/dl4.png">
                </dt>
                <dd>拍店赚钱</dd>
            </dl>
            <dl class="dl1">
                <router-link to='/news'>
                    <dt>
                        <img src="../../../static/images/home/dl5.png">
                    </dt>
                    <dd>热点资讯</dd>
                </router-link>
            </dl>
        </div>
    </div>
    
    <!-- 我要转铺 我要找店 -->
    <div class="zp-wrap">
        <ul>
            <li :class="{'on':showZpNum==0}"  @click="zhuanpuFun">我要转铺</li>
            <li :class="{'on':showZpNum==1}"  @click="zhaopuFun">我要找店</li>
        </ul>
        <!-- 转铺 -->
        <div class="zp-box-wrap" v-if="showZhuanpu">
            <!-- 无数据 -->
            <dl class="zp-null-dl" v-if="showZhuan == 0">
                <dt>
                    <!-- <h3>在线出租商铺方便省心&nbsp;<span>准扶贫怎样!</span></h3> -->
                    <h3>在线出租商铺方便省心</h3>
                    <h5>方便快捷／安全省心／专属顾问</h5>
                    <p @click="goPublishop()">发布商铺<img src="../../../static/images/home/right-white.png"></p>
                </dt>
                <dd>
                    <img src="../../../static/images/home/zhuanpu-bg.png" alt="" class="zhuanpu-bg-img" />
                </dd>
            </dl>
            <!-- 有数据 -->
            <div class="zhuanpu-wrap" v-if="showZhuan == 1">
                <mt-swipe :auto="0" :continuous=false :show-indicators="false">
                    <mt-swipe-item v-for="(item,index) in zhuanpuList" style="width: 6.7rem; height: 2.2rem;">
                        <div class="zhuanpu-box" @click="goZhuanpudetail(item.id)">
                            <img :src="item.imgs" class="shopImg" alt="" />
                            <h3>{{item.shop_name}}</h3>
                            <span v-if="item.top_status == 1">置顶</span>
                            <h4>{{item.monthlyRent}}{{item.unitMonthRent}}</h4>
                            <p>商铺管理</p>
                        </div>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
        </div>
        
        <!-- 找铺 -->
        <div class="zp-null zhao-box zp-box-wrap" v-if="showZhaopu">
            <!-- 找铺 无 -->
            <dl class="zp-null-dl" v-if="showZhao == 0">
                <dt>
                    <!-- <h3><span>10万套商铺精</span>准扶贫怎样!</h3> -->
                    <h3>顾问1对1帮您找好铺</h3>
                    <h5>真实好铺/定制推荐/极速响应</h5>
                    <p @click="goPublishneed()">一键发布<img src="../../../static/images/home/right-white.png"></p>
                </dt>
                <dd>
                    <img src="../../../static/images/home/zhaopu-bg.png" alt="" class="zhaopu-bg-img" />
                </dd>
            </dl>
            <!-- 有 -->
            <div class="zhaopu-wrap" v-if="showZhao == 1">
                <mt-swipe :auto="0" :continuous=false :show-indicators="false">
                    <mt-swipe-item v-for="(item,index) in zhaopuList" style="width: 6.7rem; height: 2.2rem;">
                        <div class="zhaopu-box" @click="goZhaopudetail(item.id)">
                            <h4>{{item.name}}</h4>
                            <h5><span>面积：</span>{{item.area}}</h5>
                            <h5><span>租金：</span>{{item.monthly}}</h5>
                            <p>需求管理</p>
                        </div>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
        </div>

        <dl class="zp-footer" v-if="showZhuanpu">
            <!-- <dt><img src="../../../static/images/shopDetail/consultant1.png" alt="" class="consultant-img" /></dt> -->
            <dt v-if="customer.image"><img :src="customer.image" alt="" class="consultant-img" /></dt>
            <dt v-else ><img src="../../../static/images/shopDetail/consultant1.png" alt="" class="consultant-img"/></dt>

            <dd>
                <p>服务顾问&nbsp;{{customer.name}}</p>
                <h5>超10万真实客户&nbsp;最快48小时成交</h5>
            </dd>
            <div class="free-zx" @click="goMessageuser()">免费咨询<img src="../../../static/images/home/right-gray.png"></div>
        </dl>

        <dl class="zp-footer" v-if="showZhaopu">
            <!-- <dt><img src="../../../static/images/shopDetail/consultant1.png" alt="" class="consultant-img" /></dt> -->
            <dt v-if="customer.image"><img :src="customer.image" alt="" class="consultant-img" /></dt>
            <dt v-else ><img src="../../../static/images/shopDetail/consultant1.png" alt="" class="consultant-img"/></dt>

            <dd>
                <p>服务顾问&nbsp;{{customer.name}}</p>
                <h5>全城帮您租好铺&nbsp;最快24小时成交</h5>
            </dd>
            <div class="free-zx" @click="goMessageuser()">免费咨询<img src="../../../static/images/home/right-gray.png"></div>
        </dl>

    </div>

    <!-- 大咖推荐 -->
    <div class="big-caffeine">
        <div class="big-caffeine-top">
            <h3>大咖推荐</h3>
        </div>
        <div class="big-caffeine-box">
            <p>
                <span v-for="item in bigCaffeineArr">
                    <img :src="item.Imgaddress">
                    <ul>
                        <h5>{{item.name}}</h5>
                        <li><h6>{{item.position}}</h6></li>
                    </ul>
                </span>
            </p>
        </div>
    </div>

    <!-- 合作品牌 -->
    <div class="co-branding">
        <div class="co-branding-top">
            <h3>合作品牌</h3>
            <router-link to="/cooperation">
                <h4>查看全部<img src="../../../static/images/home/more.png"></h4>
            </router-link>
        </div>
        <div class="co-branding-box">
            <p>
                <span v-for="item in coBrandingArr"><img :src="item.img"></span>
            </p>
        </div>
    </div>

    <div class="popupWrap" v-if="isShowPopup">
        <div class="popupBox">
            <h2>温馨提示</h2>
            <p>该功能只限租铺宝APP使用</p>
            <div>
                <span class="span1" @click="isShowPopup = false">取消</span>
                <span class="span2"><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.example.dc.zupubao">去下载</a></span>
            </div>
        </div>
    </div>
    
    <!-- 城市切换弹窗 -->
    <div class="cityChangeWrap" v-if="isShowCityChangeWrap">
        <div class="cityChangeBox">
            <h2>温馨提示</h2>
            <p>是否切换到当前城市：{{locationCityNameStr}}</p>
            <div>
                <span class="span1" @click="cancelChangeUrlFun()">否</span>
                <span class="span2" @click="changeUrlFun()">是</span>
            </div>
        </div>
    </div>
    <div class="homeMain">
        <div class="homeMain-top">
            <h3>今日热门</h3>
            <!-- <router-link :to="{name:'cooperation'}"> -->
            <router-link :to="{name:'lookShop'}">
                <h4>查看更多<img src="../../../static/images/home/more.png"></h4>
            </router-link>
        </div>
        <div class="detail">
            <ul>
                <li v-for="(item,index) in shopListArr" @click="goShop(item.id,item.type)">
                    <div class="wrap">
                        <div class="img">
                            <img :src="item.img" alt="" :onerror="defaultImg">
                            <!-- <div v-if="item.type==1" class="xinshang"></div>
                            <div v-else-if="item.type==2" class="remeng"></div>
                            <div v-else-if="item.type==3" class="chengjiao"></div>
                            <div v-else-if="item.type==4" class="jingxuan"></div> -->
                            <div class="videoImgWrap">
                                <img src="../../../static/images/common/video.png" v-if="item.video != ''" class="videoImg">
                            </div>
                        </div>
                        <div class="msg">
                            <!-- <h4>{{item.title}}</h4> -->
                            <h4>{{item.shopName}}</h4>
                            <!-- <p>{{item.shopName}}</p> -->
                            <div class="tags" v-if="item.shopTags"><span v-if="index1 < 3" v-for="(item1,index1) in item.shopTags">{{item1}}</span></div>
                            <div class="price">{{item.monthlyRent}}<span>{{item.unit}}</span></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="shopWrite"></div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
import shopList from '@/components/shop/shopList.vue'
export default {
    name: 'home',
    data () {
        return {
            defaultImg: 'this.src="' + require('../../../static/images/lookShop/err.png') + '"',
            // 控制搜索栏显示隐藏
            searchBar: false,
            // 新闻数组
            prizeList:[],
            // 新闻滚动
            activeIndex: 0,
            // 轮播图数组
            picArr: [],
            // 24小时房源
            PropertyObj: {},
            // 在线商铺
            onLineShopObj: {},
            // 正在找铺
            seekShopObj: {},
            // 商铺列表展示
            shopListArr: [],
            //下载显示隐藏
            downing: true,
            typeIndex: "",// 判断是否为当前页面
            // 合作品牌
            coBrandingArr:[],
            // 大咖推荐
            bigCaffeineArr: [],
            dailyRent: "", //日租金
            shopRate: "", //环比上月
            sessionCityId: "",  // 全局城市Id

            cityNameStr: "", //城市名称
            iphoneCookie: "",
            tokenCookie: "",

            isShowCityChangeWrap: false, //是否出现弹窗
            changeUrl: "", //定位切换路径

            isChangeCity: "", //是否提示切换页面
            locationCityNameStr: "", //获取定位城市

            navBarFixed: false,

            showZhuanpu: true, //我要转铺
            showZhaopu: false,

            showZpNum: 0,

            showZhuan: 0,
            showZhao: 0,

            zhuanpuList: [], //我要转铺数据
            zhaopuList: [],

            customer: "", //顾问信息

            isShowPopup: false, //提示下载app

            typeId: "",

            typeZhaopuNum: "",
            typeZhuanpuNum: ""

        }
    },
    computed:{
        // 新闻滚动
        top() {
            return - this.activeIndex * .8 + 'rem';
        }
    },
    beforeCreate: function () {
        // console.group('beforeCreate 创建前状态===============》');
    },
    methods:{
        
        // 跳转发布商铺
        goPublishop(){

            this.isShowPopup = true;

            // if(!localStorage.iphone){
            //     this.$router.push({path:"/login", query:{urlType:"home"}});
            // }else{
            //     this.$router.push({path:"/publishop", query:{guwenid: this.customer.id}});
            // }
        },
        // 跳转发布需求
        goPublishneed(){

            this.isShowPopup = true;

            // 跳转商铺求租
            // if(!localStorage.iphone){
            //     this.$router.push({path:"/login", query:{urlType:"home"}});
            // }else{
            //     this.$router.push({path:"/publishneed", query:{guwenid: this.customer.id}});
            // }
        },
        // 跳转会话
        goMessageuser(){
            // 跳转商铺求租
            if(!localStorage.iphone){
                this.$router.push({path:"/login", query:{urlType:"home"}});
            }else{
                // this.$router.push({path:"/messageuser", query:{guwenid:"39"}});

                let _this = this;

                if(this.showZhuanpu == true){
                    this.typeId = this.typeZhuanpuNum;
                }else{
                    this.typeId = this.typeZhaopuNum;
                }

                // alert(this.typeId);

                // alert(this.customer.id);

                let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
                axios(url,{
                    method: 'post',
                    params:{
                        senderId: localStorage.rcUserId, //发送人ID
                        targetIds: this.customer.id, //接收人ID
                        shopId: "", //商铺ID
                        type: this.typeId,
                        // source: "1",//  string  是   触发来源 1：详情 2：推荐
                    }
                }).then(data => {

                    console.log(data);
                     
                }).catch(err => {
                    console.log(err)
                });


                window.location.href="/messageuser?guwenid=" + this.customer.id;
            }
        },

        // 我要转铺 我要找店
        zpData() {
            let _this = this
            let url = _this.changeData() + '/show/getUserStatus';
            axios(url,{
                method: 'post',
                // params:{
                //     cityId: sessionStorage.cityId //市 id
                // }
            }).then(data => {

                // console.log(data);
                this.customer = data.data.data.customer; //顾问信息
                this.zhuanpuList = data.data.data.shopList; // 我要转铺 

                // console.log("顾问信息");
                // console.log(this.customer);


                if(this.zhuanpuList.length==0){
                    this.showZhuan = 0;
                    this.typeZhuanpuNum = "0_5";
                }else{
                    this.showZhuan = 1;
                    this.typeZhuanpuNum = "0_6";
                }

                this.zhaopuList = data.data.data.shopRentingList; //我要找店

                if(this.zhaopuList.length==0){
                    this.showZhao = 0;
                    this.typeZhaopuNum = "0_7";
                }else{
                    this.showZhao = 1;
                    this.typeZhaopuNum = "0_8";
                }

            }).catch(err => {
                console.log(err)
            });
        },


        // 我要转铺
        zhuanpuFun(){
            this.showZpNum = 0;
            this.showZhuanpu = true;
            this.showZhaopu = false;
        },

        // 我要转铺
        zhaopuFun(){
            this.showZpNum = 1;
            this.showZhaopu = true;
            this.showZhuanpu = false;
        },


        goZhaopudetail(shopId){

            this.isShowPopup = true;

            // this.$router.push({path:"/zhaopudetail", query:{shopId:shopId}});
        },
        goZhuanpudetail(shopId){

            this.isShowPopup = true;

            // this.$router.push({path:"/zhuanpudetail", query:{shopId:shopId}});
        },


        // 跳转搜索页
        goSearch(){
            this.$router.push({path:"/search", query:{home:1}});
        },
        // 跳转查看商铺页
        goShop(id,type){

            this.$router.push({path:"/shopDetail", query:{shopId:id,home:1,type:type}});

        },
        // 搜索栏
        handleScroll(){
            let changBG = 0;
            let scrollTop = 0;
        },
        
        // 导航滑动
        handleScroll() {
            window.addEventListener('scroll', this.handleScroll);
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // console.log(scrollTop);
            if(scrollTop >= 80){
                this.searchBar = true;
            }else{
                this.searchBar = false;
            }
        },

        // 点击拨打电话
        telephone() {
            layer.open({
                content: '<h2>业务咨询 | 服务投诉热线</h2><p>010-85951005</p >',
                btn: ['拨打', '取消'],
                yes: function(index){
                    layer.close(index);
                    window.location.href="tel:010-85951005"
                },
                skin: 'tel'
            });
        },

        // 跳转城市选择
        goCitySelection(){
            this.$router.push({path: '/citySelection', query:{cityName: this.cityNameStr}});
        },
        // 滑到底部跳转商铺列表
        addScroll:function() {
            window.addEventListener("scroll",this.sa,false)
        },
        sa() {
            let _this = this;
            let webHeight=document.body.offsetHeight
            let screenHeight=window.innerHeight
            let h1 = document.body.scrollTop
            let h2 = document.documentElement.scrollTop
            let scrollTopNum
            if(h1>h2){
                scrollTopNum=h1
            }else{
                scrollTopNum=h2
            }
            let panDuan=webHeight-scrollTopNum-screenHeight
            if(panDuan === 0){
                if(_this.typeIndex == "type"){
                    this.$router.push({
                        path: '/lookShop'
                    });
                    window.removeEventListener("scroll", _this.sa);
                }
            }
        },

        // 首页展示
        listData() {
            let _this = this
            // let url = _this.changeData() + '/show/showInfo'

            let url = _this.changeData() + '/show/newShowInfo'

            axios(url,{
                method: 'post',
                params:{
                    cityId: sessionStorage.cityId //市 id
                }
            }).then(data => {
                // console.log(data);
                this.cityNameStr = data.data.data.cityName; //获取城市名
                this.picArr = data.data.data.imgUrl; //轮播图
                this.prizeList = data.data.data.title; //新闻
                this.coBrandingArr = data.data.data.getBrandLogoList; //品牌列表
                this.bigCaffeineArr = data.data.data.higherlist; //大咖列表
                // this.shopListArr = data.data.data.djskList; // 独家实勘商铺列表

                this.shopListArr = data.data.data.jrrmList; // 独家实勘商铺列表

                this.PropertyObj = data.data.data.shopNewNum; //24小时房源
                this.onLineShopObj = data.data.data.shopLineNum; //在线商铺
                this.seekShopObj = data.data.data.peopleNum; //正在找铺
                this.dailyRent = data.data.data.dailyRent; //日租金
                this.shopRate = data.data.data.shopRate; //环比上月
            }).catch(err => {
                console.log(err)
            });
        },

        // 跳转新闻详情页
        goNews(id){
            this.$router.push({path: '/consult', query:{id: id}});
        },
        // 点击轮播图 跳转详情页
        goNewInfo(id,url,flag) {
            if(flag == "true"){
                window.location.href = url;
            }else{
                this.$router.push({path: '/consult', query:{id: id}});
            }
        },

        // 跳转商铺详情
        goEcharts(){
            this.$router.push({path:"/echarts", query:{url:"home",cityId:sessionStorage.cityId}});
        },
        // 跳转发布列表
        goPublish(){
            this.$router.push({path:"/publish", query:{url:"home"}});
        },
        // 跳转商铺求租
        goQiuzu(){
            if(!localStorage.iphone){
                this.$router.push({path:"/login", query:{urlType:"home"}});
            }else{
                this.isUpperLimit();
            }
        },
        // 跳转商铺求租
        goMakeMoney(){
            if(!localStorage.iphone){
                this.$router.push({path:"/login", query:{urlType:"home"}});
            }else{
                // this.isUpperLimit();
                this.$router.push({path:"/makeMoney"});
            }
        },

        // 判断是否达到上限次数
        isUpperLimit(){
            let _this = this;
            let url = this.changeData() + '/publish/auth/isPublish'
            axios(url,{
                method: 'post',
                params: {
                    cityId: sessionStorage.cityId, 
                    type: "2"  // 求租
                }
            }).then(data => {
                // console.log(data);
                if(data.data.flag == true){
                    this.$router.push({path:"/qiuzu", url: "home"})
                }else{
                    layer.open({
                        content: '您当月的3条求租发布权限已用尽，不可再次发布',
                        skin: 'msg',
                        time: 2
                    });
                }
            }).catch(err => {
                console.log(err)
            });
        },

        //城市定位
        cityFun(){
            let _this = this;
            function myFun(result){
                var locationCityName = result.name;
                _this.locationCityNameStr = locationCityName;
                // console.log("定位城市");
                // console.log(locationCityName);
                let url = _this.changeData() + '/show/changeCity'
                axios(url,{
                    method: 'post',
                    params: {
                        "cityName": locationCityName,
                    }
                }).then(data => {
                    // console.log(data);
                    if(data.data.code == "101"){
                        
                        // 本地调试

                         //sessionStorage.setItem("provinceId",data.data.provinceId);
                         //sessionStorage.setItem("cityId",data.data.cityId);

                         //var cityNameSplit =  locationCityName.split("市").join("");
                         //sessionStorage.setItem("cityName",cityNameSplit);
                         //_this.sessionCityId = sessionStorage.cityId;
                         //if(_this.sessionCityId){
                          //   _this.listData();
                         //}

                        // 正式环境
                        // 如果在开通列表之内

                        if(data.data.status == true){
                            _this.changeUrl = data.data.m_url;
                            _this.isChangeCity = sessionStorage.isChangeCity;
                            // 提醒用户是否需要切换成为当前城市(只提示一次)
                            setTimeout(function () {
                                if(_this.isChangeCity == undefined || _this.isChangeCity == null || _this.isChangeCity == ""){
                                    if(locationCityName != sessionStorage.cityName){
                                        _this.isShowCityChangeWrap = true;
                                    }
                                }
                            },500);
                        }
                        
                    }
                }).catch(err => {
                    console.log(err)
                });
            }
            var myCity = new BMap.LocalCity();
            myCity.get(myFun);
        },

        // 城市切换
        changeUrlFun(){
            // console.log(this.changeUrl);
            window.location.href = this.changeUrl;
        },
        //取消切换城市
        cancelChangeUrlFun(){
            sessionStorage.setItem("isChangeCity","true");
            this.isShowCityChangeWrap = false;
        },

        watchScroll () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //  当滚动超过 50 时，实现吸顶效果
            if (scrollTop > 49) {
              this.navBarFixed = true
            } else {
              this.navBarFixed = false
            }
        }

    },
    updated(){

    },
    mounted() {

        // 事件监听滚动条
        window.addEventListener('scroll', this.watchScroll)

        // 新闻滚动
        setInterval(_ => {
            if(this.activeIndex < this.prizeList.length) {
                this.activeIndex += 1;
            } else {
                this.activeIndex = 0;
            }
        }, 2500);

        // 城市定位
        let that = this;
        
        setTimeout(function () {
            that.listData();
        },500);
        this.cityFun();

        // 获取cookie
        function getCookie(sName){
            var aCookie = document.cookie.split("; ");
            for (var i=0; i < aCookie.length; i++){
                var aCrumb = aCookie[i].split("=");
                if (sName == aCrumb[0])
                return unescape(aCrumb[1]);
            }
            return null;
        }
        this.iphoneCookie = getCookie("iphone");
        this.tokenCookie = getCookie("token");

        if(this.iphoneCookie){
            localStorage.iphone = this.iphoneCookie;
            localStorage.token = this.tokenCookie;
        }else{
            localStorage.clear();
        };

        // alert(this.tokenCookie);


        // if(this.tokenCookie){
            this.zpData();
        // }
    },
    components:{
        // shopList
    },
    created() {
        this.typeIndex = "type";
        this.handleScroll();
        // 接口调用
        this.listData();
    }
}
</script>

<style scoped lang="scss">
@import "../../../static/css/shopList.scss";
.shopWrite{
    width: 7.5rem;
    height: 1rem;
    background: #fff;
}
.detail{
    padding-top: 0;
}
*{margin: 0; padding: 0;}
ul,li,ol{list-style: none; box-sizing: border-box;}

.home{
    width: 7.5rem;
    background: #fff;
}

input::-webkit-input-placeholder{
    color: #ccc;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #ccc;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:  #ccc;
}
.searchNav{
    width: 6.9rem;
    height: .66rem;
    margin: 0 auto;
    padding: .11rem .3rem;
    background: #fff;
    dl{
        width: 6.4rem;
        float: left;
        dt{
            width: 1.1rem;
            float: left;
            font-size: .28rem;
            color: #333;
            line-height: .66rem;
            overflow: hidden;
            span{
                display: block;
                height: .6rem;
                width: .6rem;
                overflow: hidden;
                float: left;
            }
            b{
                display: inline-block;
                width:0;
                height:0;
                border-width: .1rem .1rem 0;
                border-style:solid;
                border-color: #333 transparent transparent;
                position: relative;
                left: .1rem;
                top: -.04rem;
            }
        }
        dd{
            width: 5rem;
            height: .66rem;
            background: #f7f7f7;
            float: left;
            border-radius:33px;
            span{
                display: inline-block;
                width: .28rem;
                height: .28rem;
                margin-left: .3rem;
                img{
                    width: .28rem;
                    height: .28rem;
                }
            }
            p{
                display: inline-block;
                line-height: .66rem;
                font-size: .26rem;
                color: #cdcdcd;
            }
        }
    }
    i{
        width: .5rem;
        display: block;
        float: left;
        line-height: .66rem;
        img{
            width: .5rem;
            height: .5rem;
        }
    }
}

/*轮播图*/
.homeTop{
    width: 6.7rem;
    height: 3.66rem;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
    background: #fff;
    margin: .2rem auto 0;
    img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
}

/*图标*/
.homeCenter{
    width: 7.5rem;
    height: 2.1rem;
    overflow: hidden;
    margin: 0 auto;
    padding-top: .5rem;
    div{
        width: 100%;
        height: 2.5rem;
        display: box;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;

        dl{
            width: 1.1rem;
            height: 1.5rem;
            margin-right: .65rem;
            text-align: center;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            dt{
                margin-top: 0rem;
                img{
                    width: .9rem;
                    height: .9rem;
                }
            }
            dd{
                font-size: 0.26rem;
                color: #111;
                line-height: .38rem;
                margin-top: .2rem;
            }
            a{
                color: #333;
            }
        }
    }
}

/* 我要转铺 我要找店 */
.zp-wrap{
    width: 6.7rem;
    height: 4.56rem;
    margin: 0 auto .3rem;
    background: #fff;
    box-shadow:0px 10px 62px 3px rgba(0,0,0,0.05);
    border-radius: 16px;
    border: 1px solid rgba(224,224,224,1);
    ul{
        height: 1.1rem;
        width: 5.9rem;
        border-bottom: 1px solid #f4f4f4;
        margin: 0 auto;
        li{
            font-size: .32rem;
            font-weight: 500;
            color: #999;
            height: 1.1rem;
            float: left;
            margin-right: .78rem;
            line-height: 1.1rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            &.on{
                color: #333;
                border-bottom: none;
                border-bottom: 4px solid #eee;
            }
        }        
    }
    .zp-box-wrap{
        width: 6.7rem;
        height: 2.02rem;
        .zp-null-dl{
            height: 2.02rem;
            margin-left: .4rem;
            dt{
                float: left;
                h3{
                    font-size: .34rem;
                    font-weight:600;
                    color: #333;
                    line-height: .46rem;
                    margin-top: .2rem;
                    span{
                        color: #de4b4f;
                    }
                }
                h5{
                    font-size: .28rem;
                    font-weight: 400;
                    color: #666;
                    line-height: .46rem;
                    margin: .04rem 0 .12rem;
                }
                p{
                    width: 1.78rem;
                    height: .58rem;
                    background: #de4b4f;
                    border-radius: 29px;
                    font-size: .28rem;
                    font-weight: 500;
                    color: #fff;
                    line-height: .58rem;
                    text-align: center;
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                    img{
                        width: .15rem;
                        height: .24rem;
                        position: relative;
                        left: .12rem;
                        top: -.03rem;
                    }
                }
            }
            dd{
                float: right;
                width: 2.2rem;
                height: 2rem;
                img{
                    width: 2.2rem;
                    height: 2rem; 
                }
            }
        }
    }
    /*找铺*/
    .zhaopu-wrap{
        width: 6.7rem;
        height: 2.02rem;
        .zhaopu-box{
            width: 5.9rem;
            padding: .3rem .4rem 0 .4rem;
            height: 1.72rem;
            position: relative;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            h4{
                width: 6rem;
                font-size: .28rem;
                font-weight: 500;
                color: #333;
                line-height: .36rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            h5{
                font-size: .28rem;
                font-weight: 600;
                color: #de4b4f;
                line-height: .36rem;
                margin-top: .2rem;
                span{
                    font-weight: 400;
                    color: #333;
                }
            }
            p{
                position: absolute;
                right: .3rem;
                bottom: .2rem;
                width: 1.56rem;
                height: .58rem;
                background: #4a90e2;
                border-radius: 29px;
                line-height: .58rem;
                text-align: center;
                font-size: .26rem;
                font-weight: 500;
                color: #fff;
                line-height: .58rem;
            }
        }
    }
    /*转铺*/
    .zhuanpu-wrap{
        width: 6.7rem;
        height: 2.02rem;
        .zhuanpu-box{
            width: 5.9rem;
            padding: .3rem .4rem 0 .4rem;
            height: 1.72rem;
            position: relative;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            .shopImg{
                width: 1.84rem;
                height: 1.38rem;
                float: left;
                margin-right: .2rem;
                border-radius: 6px;
            }
            h3{
                width: 3.1rem;
                font-size: .28rem;
                font-weight: 500;
                line-height: .44rem;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            span{
                display: inline-block;
                width: .56rem;
                height: .36rem;
                background: #a6a6a6;
                border-radius: 4px;
                font-size: .22rem;
                font-weight: 400;
                color: #fff;
                line-height: .36rem;
                text-align: center;
                position: absolute;
                right: .3rem;
                top: .3rem;
            }
            h4{
                font-size: .28rem;
                font-weight:600;
                color: #de4b4f;
                line-height: .36rem;
                position: absolute;
                left: 2.45rem;
                bottom: .4rem;
            }
            p{
                position: absolute;
                right: .3rem;
                bottom: .2rem;
                width: 1.56rem;
                height: .58rem;
                background: #4a90e2;
                border-radius: 29px;
                line-height: .58rem;
                text-align: center;
                font-size: .26rem;
                font-weight: 500;
                color: #fff;
                line-height: .58rem;
            }
        }
    }
    .zp-footer{
        width: 6.1rem;
        padding: .3rem .3rem 0 .3rem;
        border-top: 1px solid #f4f4f4;
        position: relative;
        dt{
            float: left;
            width: .8rem;
            height: .8rem;
            margin-right: .2rem;
            border-radius: 50%;
            img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        dd{
            float: left;
            p{
                font-size: .26rem;
                font-weight: 400;
                color: #666;
                line-height: .36rem;
                margin: .03rem 0;
            }
            h5{
                font-size: .24rem;
                font-weight: 500;
                line-height: .36rem;
                color: #333;
            }
        }
        .free-zx{
            font-size: .24rem;
            font-weight: 500;
            color: #4a90e2;
            margin-left: 1rem;
            position: absolute;
            right: .3rem;
            top: .7rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            img{
                margin-left: .1rem;
                width: .12rem;
                height: .2rem;
                position: relative;
                top: -.02rem;
                left: 0;
            }            
        }
    }
}

/*搜索图标*/
.search-icon{
    position: absolute;
    right: 0.3rem;
    bottom: 0.3rem;
   -webkit-tap-highlight-color: rgba(0,0,0,0);
   z-index: 10000;
}
.search-icon img{
    width: 0.7rem;
    height: 0.7rem;
}

/*咨询*/
.backdrop-img{
    width: 6.7rem;
    height: .5rem;
    margin: .4rem auto .3rem;
}
.suggest{
    line-height: 0.5rem;
    font-size: 0.26rem;
    ul{
        width: 2.1rem;
        height: 0.5rem;
        float: left;
        .li1{
            width: 1.2rem;
            height: 0.3rem;
            float: left;
            img{
                width: 100%;
                height: 100%;
                position: relative;
                top: -.02rem;
                left: 0px;
            }
        }
        .li2{
            width: 0.46rem;
            height: 0.24rem;
            margin-left: .3rem;
            float: left;
            img{
                width: 100%;
                height: 100%;
                position: relative;
                top: -.02rem;
                left: 0px;
            }

        }
    }
    .scroll-wrap{
        text-align: left;
        float: left;
        width: 4.6rem;
        overflow: hidden;
    }
}

.homeMain{
    background: #fff;
    margin-top: 0.2rem;
    .homeMain-top{
        height: .4rem;
        background: #fff;
        margin-top: .5rem;
        h3{
            margin-left: 0.4rem;
            font-size: 0.38rem;
            float: left;
            color: #363636;
            font-weight: 500;
        }
        h4{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            font-size: 0.34rem;
            float: right;
            color: #aaa;
            font-size: 0.28rem;
            padding-right: 0.4rem;
            img{
                width: 0.26rem;
                height: 0.26rem;
                position: relative;
                top: -0.02rem;
                margin-left: .08rem;
            }
        }
    }
}
/*app下载页*/
.downing{
    width: 7.5rem;
    height: .88rem;
    line-height: .88rem;
    background: rgba(255,255,255,.8);
    z-index: 1000;
    span{
        display: inline-block;
        width: .6rem;
        height: .6rem;
        background: url("../../../static/images/shopDetail/xiazai.png") no-repeat;
        -webkit-background-size: .6rem .6rem;
        background-size: .6rem .6rem;
        vertical-align: middle;
        margin: 0 .3rem 0 .2rem;
    }
    b{
        font-size: .28rem;
        display: inline-block;
        vertical-align: middle;
        color: #666;
    }
    a{
        display: inline-block;
        vertical-align: middle;
        width: 1.56rem;
        height: .6rem;
        line-height: .65rem;
        border: 1px solid #64ABFF;
        color: #64ABFF;
        border-radius: .1rem;
        text-align: center;
        margin: 0 .2rem;
        font-size: .28rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
   s{
        display: inline-block;
        vertical-align: middle;
        width: .32rem;
        height: .32rem;
        background: url("../../../static/images/shopDetail/close.png") no-repeat;
        -webkit-background-size: .32rem .32rem;
        background-size: .32rem .32rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        position: relative;
        top: 0;
        right: .1rem;
    }
}
/*本月租金均价*/
.averagePrice{
    width: 7.5rem;
    height: 4.2rem;
    background: #fff;
    border-top: .1rem solid #f6f8f9;
    border-bottom: .1rem solid #f6f8f9;
    .averagePriceTop{
        width: 7.1rem;
        height: .36rem;
        background: #fff;
        padding: .5rem .2rem .6rem .2rem;
        position: relative;
        h3{
            font-size: 0.38rem;
            float: left;
            color: #363636;
            font-weight: 500;
        }
        h4{
            float: right;
            color: #9f9fa8;
            font-size: 0.26rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            img{
                width: 0.26rem;
                height: 0.26rem;
                position: relative;
                top: -0.02rem;
                margin-left: .08rem;
            }
        }
    }
    .averagePriceBox{
        width: 5.5rem;
        margin: 0 auto;
    }
    .monthPrice{
        width: 4.4rem;
        margin: 0 auto;
        text-align: center;
        dt{
            color: #363636;
            font-size: .6rem;
            font-weight: 600;
            line-height: .6rem;
            span{
                font-size: .3rem;
                color: #363636;
                font-weight: 400;
                line-height: .6rem;
                margin-left: .1rem;
            }
        }
        dd{
            display: inline-block;
            background: #2f7af7;
            border-radius: 18px;
            padding: 0 .18rem;
            color: #fff;
            line-height: .4rem;
            font-size: .2rem;
        }
    }
}
.property{
    width: 100%;
    height: 1rem;
    dl{
        width: 25%;
        box-sizing: border-box;
        float: left;
        font-size: 0.24rem;
        text-align: center;
        margin-top: .3rem;
        dt{
            font-size: 0.34rem;
            font-weight: 600;
            color: #363636;
            span{
                font-size: 0.24rem;
                color: #363636;
                margin-left: 0.02rem;
            }
        }
        dd{
            height: 0.4rem;
            line-height: 0.4rem;
            color: #9f9fa8;
            font-size: .2rem;
        }
    }
    .dl2{
        width: 50%;
    }
}

/* 合作品牌 */
.co-branding{
    width: 7.5rem;
    background: #fff;
    padding-bottom: .3rem;
    .co-branding-top{
        background: #fff;
        margin-top: .4rem;
        height: .5rem;
        h3{
            margin-left: 0.4rem;
            font-size: 0.38rem;
            float: left;
            color: #363636;
            font-weight: 500;
        }
        h4{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            font-size: 0.34rem;
            float: right;
            color: #aaa;
            font-size: 0.26rem;
            padding-right: 0.2rem;
            img{
                width: 0.26rem;
                height: 0.26rem;
                position: relative;
                top: -0.02rem;
                margin-left: .08rem;
            }
        }
    }
    .co-branding-box{
        width: 7.5rem;
        height: 1.6rem;
        overflow: hidden;
        p{
            width: 100%;
            height: 1.8rem;
            display: box;
            display: -webkit-box;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            span{
                width: 1.6rem;
                height: 1.2rem;
                margin-right: .2rem;
                display: block;
                box-shadow: 0px 0px 6px rgba(231,231,231,1);
                box-sizing: border-box;
                margin-top: .2rem;
                border-radius: 10px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 10px;
                }
            }
            :nth-child(1){
                border-left: .01rem solid #eaeaea;
            }
            :nth-child(9){
                border-right: .01rem solid #eaeaea;
            }
        }
    }
}

/*大咖推荐*/
.big-caffeine{
    width: 7.5rem;
    padding-top: .2rem;
    padding-bottom: .3rem;
    background: #fff;
    border-top: .1rem solid #f6f8f9;
    border-bottom: .1rem solid #f6f8f9;
    .big-caffeine-top{
        height: 1rem;
        background: #fff;
        h3{
            line-height: 1rem;
            margin-left: 0.3rem;
            font-size: 0.38rem;
            float: left;
            color: #363636;
            font-weight: 500;
        }
        h4{
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            font-size: 0.34rem;
            float: right;
            line-height: 1rem;
            color: #aaa;
            font-size: 0.26rem;
            padding-right: 0.4rem;
            img{
                width: 0.26rem;
                height: 0.26rem;
                position: relative;
                top: -0.02rem;
                margin-left: .08rem;
            }
        }
    }
    .big-caffeine-box{
        width: 7.5rem;
        height: 2.32rem;
        overflow: hidden;
        p{
            width: 100%;
            height: 3rem;
            display: box;
            display: -webkit-box;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
            span{
                width: 1.56rem;
                height: 2.32rem;
                margin-right: .2rem;
                display: block;
                position: relative;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
                ul{
                    width: 100%;
                    height: .8rem;
                    padding: .1rem;
                    position: absolute;
                    bottom: 0px;
                    background: rgba(0,0,0,0.5);
                    z-index: 100;
                    color: #fff;
                    overflow: hidden;
                    z-index: 1;
                    border-radius: 0 0 4px 4px;
                    h5{
                        font-size: .2rem;
                        line-height: .2rem;
                    }
                    h6{
                        width: 1.38rem;
                        margin-top: .04rem;
                        font-size: .16rem;
                        line-height: .2rem;
                        text-align: justify;
                        overflow: hidden;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
        }
    }
}

/*城市切换弹窗*/
.cityChangeWrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 100000000;
    .cityChangeBox{
        width: 6rem;
        height: 3.2rem;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 32%;
        margin-left: -3rem;
        border-radius: 6px;
        overflow: hidden;

        h2{
            color: #444;
            text-align: center;
            line-height: 1.2rem;
            margin-top: .2rem;
            font-size: .4rem;
        }
        p{
            color: #444;
            text-align: center;
            font-size: .3rem;
            color: #444;
        }
        div{
            width: 100%;
            height: .88rem;
            /*background: red;*/
            position: absolute;
            left: 0;
            bottom: 0;
            span{
                display: inline-block;
                width: 50%;
                line-height: .88rem;
                float: left;
                text-align: center;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
            }
            .span1{
                background: #eee;
            }
            .span2{
                background: #64ABFF;
                color: #fff;
            }
        }
    }
}

/*下载APP弹窗*/
.popupWrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 100000000;
    .popupBox{
        width: 6rem;
        height: 3.2rem;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 32%;
        margin-left: -3rem;
        border-radius: 6px;
        overflow: hidden;
        h2{
            color: #444;
            text-align: center;
            line-height: 1.2rem;
            margin-top: .2rem;
            font-size: .4rem;
        }
        p{
            color: #444;
            text-align: center;
            font-size: .3rem;
            color: #444;
        }
        div{
            width: 100%;
            height: .88rem;
            position: absolute;
            left: 0;
            bottom: 0;
            span{
                display: inline-block;
                width: 50%;
                line-height: .88rem;
                float: left;
                text-align: center;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                a{
                    color: #fff;
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                }
            }
            .span1{
                background: #eee;
            }
            .span2{
                background: #64ABFF;
                color: #fff;
            }
        }
    }
}


</style>
<style>
.layui-m-layer-tel .layui-m-layercont{
    padding: 35px 30px;
}
.layui-m-layer-tel h2{
    font-size: .32rem;
    color: #333;
    margin-bottom: .3rem;
}
.layui-m-layer-tel p{
    font-size: .36rem;
    color: #e8584f;
}
.layui-m-layer-tel .layui-m-layerbtn span:nth-of-type(1){
    color: #898989;
    background: #f7f8fa;
    font-size: .34rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.layui-m-layer-tel .layui-m-layerbtn span:nth-of-type(2){
    color: #fff;
    background: #64AAFF;
    font-size: .34rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    border-radius: 0 0 5px 0;
}


</style>

<style type="text/css">
@-webkit-keyframes scrollText1 {
    0%{
        -webkit-transform: translateY(-0px);
    }
    30%{
        -webkit-transform: translateY(-.5rem);
    }
    60%{
        -webkit-transform: translateY(-1rem);
    }
    100%{
        -webkit-transform: translateY(-1.5rem);
    }
}

@keyframes scrollText1 {
    0%{
        transform: translateY(-0px);
    }
    30%{
        transform: translateY(-.5rem);
    }
    60%{
        transform: translateY(-1rem);
    }
    100%{
        transform: translateY(-1.5rem);
    }
}

.box3{
    position: relative;
    width: 4.6rem;
    height: .5rem;
    overflow: hidden;
}
.border3{
    top: 0px;
    -webkit-animation:scrollText1 10s infinite  cubic-bezier(1,0,0.5,0) ;
    animation:scrollText1 10s infinite  cubic-bezier(1,0,0.5,0) ;
}

.border3 div{
    height: .5rem;
    font-size: .24rem;
    color: #363636;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    line-height: .5rem;
}
.border3:hover{
    animation-play-state:paused;
    -webkit-animation-play-state:paused;
}

.mint-swipe-indicators{
    position: absolute;
    bottom: 2px;
    left: 50%;
}

.navBarWrap {
    position:fixed;
    top:0;
    z-index:999;
}
</style>




// WEBPACK FOOTER //
// src/components/home/home.vue